import CryptoJS from "crypto-js";

export const decryptPassword = (encryptedPassword) => {
    const SECRET_KEY = process.env.REACT_APP_ZOOM_PASS_ENCRYPT_SECRET;
    const bytes = CryptoJS.AES.decrypt(encryptedPassword, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
};
